import { UnfoldedMap } from "@unfolded/map-sdk";
import { useEffect, useRef } from "react";

export default function Map({ setMap, setIsMapLoaded }) {
  const mountContainerRef = useRef(null);

  useEffect(() => {
    const unfoldedMap = new UnfoldedMap({
      mapUUID: "808149bc-0fc2-4e01-ab2d-f6b7b0ef4055",
      embed: true,
      width: window.innerWidth,
      height: window.innerHeight - 5,
      onLoad: () => {
        setIsMapLoaded(true);
      },
    });
    setMap(unfoldedMap);
    mountContainerRef.current.appendChild(unfoldedMap.iframe);
  }, [setMap, setIsMapLoaded]);

  return (
    <div
      style={{
        zIndex: 1,
        position: "absolute",
        top: 0,
        left: 0,
        overflow: "hidden",
      }}
    >
      <div
        style={{ margin: 0, padding: 0, border: 0 }}
        ref={mountContainerRef}
      />
    </div>
  );
}
